import { render } from "./DateTimeField.vue?vue&type=template&id=bcfe6aca"
import script from "./DateTimeField.vue?vue&type=script&lang=js"
export * from "./DateTimeField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DateTimeField.vue"]])

export default __exports__